import { reactive } from "vue";

export const EventBus = reactive({
  isAnyChange: false,
});
